import { fetch } from 'http-common';

class GeonamesDataService {
  private http = fetch();

  private ep = '/v1/customers/geonames';

  public async get(countryCode: string, postalCode?: string) {
    return this.http.get(`${this.ep}`, {
      params: {
        countryCode,
        postalCode: postalCode || undefined,
      },
    });
  }
}

const geonamesDataService = new GeonamesDataService();

export { geonamesDataService };
